import { Deserializable } from '../../protocols/deserializable';
import { BaseType } from '../../base/base-type';

export class MemberPlanRules implements Deserializable {
  public memberId!: number;
  public serviceStartDate!: string;
  public planEntryDate: string | null = null;
  public finalTerminationDate: string | null = null;
  public workService!: number;
  public contributionService!: number;
  public age!: number;
  public agePlusWorkService!: number;
  public earlyRetirementDate!: string;
  public normalRetirementDate!: string;
  public votingRegionId: number | null = null;
  public votingRegion!: BaseType;

  public onDeserialize(): void {}
}
